import { styled } from '@mui/material/styles';
import { SelectField } from 'components/inputs';

// Styled to match old DOM and CSS
export const StyledSelectField = styled(SelectField)(({ theme }) => ({
  marginTop: '50px',
  marginBottom: '50px',
  minWidth: '100px',
  maxWidth: '320px',
  width: 'auto',
  flex: 1,

  // Override react-select internal classes
  '.select__single-value': {
    position: 'absolute',
    top: '50%',
    transform: 'translateY(-50%)',
    marginLeft: '2px',
    marginRight: '2px',
    maxWidth: 'calc(100% - 8px)',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    color: 'hsl(0, 0%, 20%)',
    boxSizing: 'border-box'
  },
  '.select__input': {
    display: 'flex !important',
    flex: '1 1 auto',
    color: 'hsl(0, 0%, 20%)',
    boxSizing: 'border-box',
    margin: 0,
    padding: 0,
    height: 'auto'
  },
  '.select__value-container': {
    position: 'relative'
  }
}));
